import { useEffect, useState } from 'react';
import { apiFetch } from './apiFetch';
import { getToken } from './PasswordGate';

export interface CurrentUser {
  id: number;
  email: string;
  displayName: string | null;
  pictureUrl: string | null;
}

export type CurrentUserState =
  | { status: 'loading'; mode: null; user: null }
  | { status: 'ready'; mode: 'real'; user: CurrentUser }
  | { status: 'ready'; mode: 'demo' | 'real-legacy'; user: null }
  | { status: 'error'; mode: null; user: null; error: string };

interface MeResponse {
  mode: 'real' | 'demo' | 'real-legacy';
  user?: CurrentUser;
}

export function useCurrentUser(): CurrentUserState {
  const [state, setState] = useState<CurrentUserState>({
    status: 'loading',
    mode: null,
    user: null,
  });

  useEffect(() => {
    let cancelled = false;
    const token = getToken();
    if (!token) {
      setState({
        status: 'error',
        mode: null,
        user: null,
        error: 'not signed in',
      });
      return;
    }
    apiFetch('/api/auth/me')
      .then(async (res) => {
        if (!res.ok) throw new Error(`me ${res.status}`);
        return (await res.json()) as MeResponse;
      })
      .then((data) => {
        if (cancelled) return;
        if (data.mode === 'real' && data.user) {
          setState({ status: 'ready', mode: 'real', user: data.user });
        } else if (data.mode === 'demo' || data.mode === 'real-legacy') {
          setState({ status: 'ready', mode: data.mode, user: null });
        } else {
          setState({
            status: 'error',
            mode: null,
            user: null,
            error: 'missing user info',
          });
        }
      })
      .catch((err: Error) => {
        if (cancelled) return;
        setState({
          status: 'error',
          mode: null,
          user: null,
          error: err.message,
        });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
